import { render } from "./descriptionBinder.vue?vue&type=template&id=5ffe49ba&ts=true"
import script from "./descriptionBinder.vue?vue&type=script&lang=ts"
export * from "./descriptionBinder.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\Auraclub\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__